import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  ISearchMessageRequest,
  ISearchMessageResponse,
  ISendMessageRequest,
  IReplyMessageRequest,
  IMarkMessageRequest,
  IMarkMessageResponse,
  IEmptyRequestResponse,
} from '@zeta-types';
import { MESSAGE_SERVICE } from '../services-path';

export const MessagingService = () => {
  return {
    searchMessage: (payload: ISearchMessageRequest): APIResponse<ISearchMessageResponse> => HttpClient.post(`${MESSAGE_SERVICE}/message/search`, payload),

    sendMessage: (payload: ISendMessageRequest): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${MESSAGE_SERVICE}/message/create`, payload),

    replyMessage: (payload: IReplyMessageRequest): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${MESSAGE_SERVICE}/message/reply`, payload),

    markMessage: (payload: IMarkMessageRequest): APIResponse<IMarkMessageResponse> => HttpClient.post(`${MESSAGE_SERVICE}/message/mark`, payload),

    getMessageCount: (payload: IEmptyRequestResponse): APIResponse<{ unread: number }> => HttpClient.post(`${MESSAGE_SERVICE}/message/count`, payload),
  };
};
